// This file is auto-generated by update-build-info.js
export const buildInfo = {
  devBuild: '413'
};
